;(function() {
  'use strict'

  Service.$inject = ["glDialog", "glUtils", "glAuthService", "configService"];
  angular.module('app.core').service('subscriberReportExporter', Service)

  /* @ngInject */
  function Service(glDialog, glUtils, glAuthService, configService) {
    this.show = show
    this.getDownloadUrl = getDownloadUrl

    function show() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="subscriber-report-exporter__dialog">',
          '<subscriber-report-exporter on-cancel="dialog.cancel()"/>',
        '</gl-dialog>',
      ]
      glDialog.show({
        template: template.join(' '),
        closeOnOutsideClick: true,
      })
    }

    function getDownloadUrl(start, end) {
      var token = glAuthService.getToken()
      var endpoint = configService.getApiUrl('/subscribers/activity-report')
      var url = glUtils.addParams(endpoint, {
        type: 'csv',
        startAt: start.toISOString(),
        endAt: end.toISOString(),
        api_token: token,
      })
      return url
    }
  }
})()
